import { http } from "../_helpers";

export const AuthService = {
  login(credentials) {
    return http
      .post("/auth/login/", credentials)
      .then(response => response.data);
  },
  signUp(credentials) {
    return http
      .post("/auth/register/", credentials)
      .then(response => response.data);
  },
  forgotPassword(credentials) {
    return http
      .post("/auth/start_reset_password", credentials)
      .then(response => response);
  },
  resetPassword(credentials) {
    return http
      .post("/auth/reset_password", credentials)
      .then(response => response);
  },
  getSecretContent() {
    return http.get("/secret-route/").then(response => response.data);
  }
};
